import { type PropsWithChildren } from 'react';

import { createActionsHook, createContainer, createStore } from '@atlassian/eoc-rss-helpers';

import { actions } from './actions';
import { type ContainerProps } from './types';

const Store = createStore<{}, typeof actions>({
	initialState: {},
	actions,
});

export const Container = createContainer<{}, typeof actions, PropsWithChildren<ContainerProps>>(
	Store,
);

export const useActions = createActionsHook(Store);
